<span class="countdown-circle" (click)="manager().timeoutSubject.next(true)">
  @if (countdown() !== -1) {
    <span class="countdown-text" [class]="countdown() >= 1000 ? 'countdown-text-over-thousand' : undefined">{{
      countdown()
    }}</span>
  } @else {
    <mat-icon>replay</mat-icon>
  }
</span>
